import React from 'react'

const ContactUs = () => {
  return (
    <div class="alert alert-warning border-0 shadow-sm rounded-3 p-4" role="alert" dir="rtl" style={{ fontFamily: "Vazir, sans-serif", lineHeight: "1.9" }}>
      <div class="d-flex align-items-center mb-2">
        <i class="bi bi-exclamation-triangle-fill fs-4 me-2 text-warning"></i>
        <h5 class="fw-bold mb-0">کاربر گرامی</h5>
      </div>
      <p class="mb-2">
        هر سوال، پیشنهاد و یا انتقادی دارید می توانید از طریق ایمیل با ما در ارتباط باشید. تیم پشتیبانی ما تلاش می کند در کوتاه ترین زمان ممکن به درخواست های شما پاسخ دهد.
      </p>
      <p class="mb-3">
        ایمیل پستیبانی: <strong>support@autoyad.ir</strong>
      </p>
      <p class="mb-3">
        نظرات شما به ما کمک می کند تا خدمات بهتری ارائه دهیم.
      </p>
      {/* نسخه برنامه در پایین */}
      <div className="text-end mt-4 pt-2 border-top text-muted small">
        {/* نسخه برنامه: {process.env.REACT_APP_VERSION} */}
        v-1.0.8
      </div>


    </div>
  )
}

export default ContactUs